import { useMemo } from 'react'
import { type NavMenuHierarchyL1 } from '../../nav-v2/NavMenuHierarchy'

const notificationPermissions: { name: string; permissionSlugs: string[] }[] = [
  {
    name: 'dashboard.permissions.notifications.subscriptionManagement',
    permissionSlugs: ['notifications.full_scope'],
  },
  {
    name: 'dashboard.permissions.notifications.insightsSummary',
    permissionSlugs: ['notifications.insights-summary-report'],
  },
  {
    name: 'dashboard.permissions.notifications.inventoryFileNormalization',
    permissionSlugs: ['notifications.inventory-file-normalization'],
  },
  {
    name: 'dashboard.permissions.notifications.marketplaceFacilitatorValidationErrors',
    permissionSlugs: ['notifications.mpf-tax-file-notifications'],
  },
  {
    name: 'dashboard.permissions.notifications.fileIngestionCriticalDataValidation',
    permissionSlugs: ['notifications.file-ingestion-critical-data-validation'],
  },
  {
    name: 'dashboard.permissions.notifications.dailyFileIngestionDataValidation',
    permissionSlugs: ['notifications.daily-file-ingestion-data-validation'],
  },
  {
    name: 'dashboard.permissions.notifications.weeklyFileIngestionDataValidation',
    permissionSlugs: ['notifications.weekly-file-ingestion-data-validation'],
  },
  {
    name: 'dashboard.permissions.notifications.storeHourUpdates',
    permissionSlugs: ['notifications.store-hour-updates'],
  },
  {
    name: 'dashboard.permissions.notifications.holidayHours',
    permissionSlugs: ['notifications.upcoming-store-hours-reminder'],
  },
]

const generalPermissions: { name: string; permissionSlugs: string[] }[] = [
  {
    name: 'dashboard.permissions.general.legacy',
    permissionSlugs: ['basic.legacy_permission'],
  },
]

export const useNonNavMenuPermissions = () => {
  const nonNavMenuPermissions: NavMenuHierarchyL1[] = useMemo(
    () => [
      {
        name: 'dashboard.permissions.sections.notifications',
        children: notificationPermissions.map(permission => ({
          name: permission.name,
          accessControl: {
            permissions: permission.permissionSlugs as any,
          },
          icon: null,
        })),
        icon: null,
      },
      {
        name: 'dashboard.permissions.sections.general',
        children: generalPermissions.map(permission => ({
          name: permission.name,
          accessControl: {
            permissions: permission.permissionSlugs as any,
          },
          icon: null,
        })),
        icon: null,
      },
    ],
    []
  )

  return { nonNavMenuPermissions }
}
